<!-- Icon -->
<script lang="ts" setup>
import { IconTypes, IconAnimation, DisplayStyle, HoverCursorTypes, TextDisplayStyle, IconFamily } from '../Enums/UiEnums';
import { computed, ref } from 'vue';
import { bootstrapPaddingLeftClass, bootstrapPaddingRightClass, BootstrapPaddingValue, bootstrapTextClass, hoverCursorStyle, iconClass } from '../lib/StyleHelpers';
import XSpan from './HtmlWrapper/XSpan.vue';
import MaterialSymbolsIcon from './Icons/MaterialSymbolsIcon.vue';

const props = withDefaults(defineProps<{
    percentage: number
}>(), {
    percentage: 0
});
function progressColor(input: number): string {
if (input <= 25) return "bg-danger"; // Red
if (input <= 75) return "bg-warning"; // Yellow
return "bg-success"; // Green
}


</script>
<style scoped>
.percent-text{
    position: absolute;
    left: 50%;
    transform: translate(-50%, -10%);
}
.percent-container{
    position: relative;
    width: 100%;
}
</style>
<template>
    <div class="container text-center percent-container">
        <div class="progress">
            <div class="progress-bar" :class="progressColor(props.percentage)"
                :style="{ width: props.percentage + '%' }">
            </div>
            <span class="percent-text text-center ml-1 z-3">
                {{ props.percentage }}%
            </span>
        </div>
    </div>
</template>